import OnePlatformCommonActions from "@frameworks/web/redux/actions/common/commonActions";
import { CONTRACT_STATEMENT } from "@frameworks/web/redux/interfaces/Reports/iContractStatement";
class ContractStatementActions extends OnePlatformCommonActions {
    getContractReport(contractReport, type) {
        this.dispatch({
            type: CONTRACT_STATEMENT,
            payload: { contractReport },
            reducerName: type,
        });
    }
}
export default ContractStatementActions;
